/* ══════════════════════════════════════════════════════════════════════════
   Collection / PLP — 19 SKUs with real photography.
   TWO independent filter axes, both readable straight off the photos:
     Shape — Food / Shapes / Creatures
     Feel  — Smooth / Textured / Glitter
   They stack (Food + Glitter narrows to both). Deep-linkable via ?cat= and
   ?feel=, which is what the homepage "Shop by" tiles point at. On Shopify
   these become collection filters + sort_by.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var SQ = window.SQ;

  var q = new URLSearchParams(location.search);
  var state = {
    fCat:  SQ.CATS[q.get('cat')]   ? q.get('cat')  : 'all',
    fFeel: SQ.FEELS[q.get('feel')] ? q.get('feel') : 'all',
    sort: 'best', qv: null
  };

  var elChips = document.querySelector('[data-chips]');
  var elFeels = document.querySelector('[data-feels]');
  var elGrid = document.querySelector('[data-grid]');
  var elCount = document.querySelector('[data-res-count]');
  var elSort = document.querySelector('[data-sort]');
  var qvRoot = document.getElementById('qvRoot');

  var EYE = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M2 12s3.5-6.5 10-6.5S22 12 22 12s-3.5 6.5-10 6.5S2 12 2 12z"/><circle cx="12" cy="12" r="2.6"/></svg>';

  /* Chips derive from the catalogue, so a 20th SKU needs no chip edit.
     Counts respect the OTHER axis, so a chip never promises an empty grid. */
  function chipDefs(key, map, allLabel, otherKey, otherVal) {
    var pool = SQ.ALL.filter(function (id) {
      return otherVal === 'all' || SQ.CATALOGUE[id][otherKey] === otherVal;
    });
    var counts = {};
    pool.forEach(function (id) {
      var v = SQ.CATALOGUE[id][key];
      counts[v] = (counts[v] || 0) + 1;
    });
    return [['all', allLabel + ' · ' + pool.length]].concat(
      Object.keys(map).map(function (v) { return [v, map[v] + ' · ' + (counts[v] || 0)]; })
    );
  }

  /* ─────────────────────────────  listing  ─────────────────────────────── */
  function visible() {
    var list = SQ.ALL.map(function (id) { return SQ.CATALOGUE[id]; })
      .filter(function (p) { return state.fCat === 'all' || p.cat === state.fCat; })
      .filter(function (p) { return state.fFeel === 'all' || p.feel === state.fFeel; });

    return list.slice().sort(function (a, b) {
      if (state.sort === 'rated') return parseFloat(b.rating) - parseFloat(a.rating) || b.count - a.count;
      if (state.sort === 'new') return b.fresh - a.fresh;
      return b.pop - a.pop;   /* bestselling */
    });
  }

  function cardHtml(p) {
    return '<div class="pcard">' +
      '<div class="pcard-bar" style="background:' + p.bar + '"></div>' +
      (p.badge ? '<span class="pcard-badge">' + p.badge + '</span>' : '') +
      '<a class="pcard-media" href="' + SQ.urlOf(p.id) + '" aria-label="View ' + p.name + '">' +
        '<img src="' + SQ.photo(p.id, 1) + '" alt="' + p.name + ' packshot" loading="lazy" width="800" height="800">' +
      '</a>' +
      '<div class="pcard-body">' +
        '<div class="pcard-row">' +
          '<a class="pcard-title" href="' + SQ.urlOf(p.id) + '"><strong class="pcard-name">' + p.name + '</strong></a>' +
          '<span class="pcard-no">NO. ' + p.no + '</span>' +
        '</div>' +
        '<p class="pcard-benefit">' + p.benefit + '</p>' +
        '<div class="pcard-row" style="align-items:center;flex-wrap:wrap;gap:8px">' +
          '<span class="rating"><span class="star">★</span> ' + p.rating + ' <i>(' + p.count + ')</i></span>' +
          '<span class="pcard-price"><strong class="price-now">' + SQ.fmt(SQ.UNIT) + '</strong></span>' +
        '</div>' +
        '<div class="pcard-actions">' +
          '<button class="kc kc--light" data-add="' + p.id + '">Add to cart</button>' +
          '<button class="kc kc--light qv-btn" data-qv="' + p.id + '" aria-label="Quick view ' + p.name + '">' + EYE + '</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  var TEASER = '<div class="coll-teaser">' +
    '<span class="teaser-q">?</span>' +
    '<div><strong class="teaser-name">Shape No. 020</strong>' +
    '<span class="teaser-sub">In the mould. Dropping in a small run — the list hears first.</span></div>' +
    '<a class="teaser-cta" href="' + SQ.homeUrl('#join') + '">JOIN THE LIST →</a>' +
  '</div>';

  function renderGrid() {
    var list = visible();
    elGrid.innerHTML = list.map(cardHtml).join('') + TEASER;
    elCount.textContent = list.length + (list.length === 1 ? ' product' : ' products');
  }

  function renderChips() {
    elChips.innerHTML = chipDefs('cat', SQ.CATS, 'All shapes', 'feel', state.fFeel)
      .map(function (c) {
        return '<button class="chip" data-chip="' + c[0] + '" aria-pressed="' +
          (state.fCat === c[0]) + '">' + c[1] + '</button>';
      }).join('');
    if (!elFeels) return;
    elFeels.innerHTML = chipDefs('feel', SQ.FEELS, 'Any feel', 'cat', state.fCat)
      .map(function (c) {
        return '<button class="chip" data-feel="' + c[0] + '" aria-pressed="' +
          (state.fFeel === c[0]) + '">' + c[1] + '</button>';
      }).join('');
  }

  /* keep the URL shareable as the filters change */
  function syncUrl() {
    var p = new URLSearchParams();
    if (state.fCat !== 'all') p.set('cat', state.fCat);
    if (state.fFeel !== 'all') p.set('feel', state.fFeel);
    var qs = p.toString();
    history.replaceState(null, '', qs ? '?' + qs : location.pathname);
  }

  /* ────────────────────────────  quick view  ───────────────────────────── */
  function renderQv() {
    if (!state.qv) { qvRoot.hidden = true; document.body.style.overflow = ''; return; }
    var p = SQ.CATALOGUE[state.qv];

    qvRoot.innerHTML =
      '<div class="scrim" data-qv-close></div>' +
      '<div class="qv" role="dialog" aria-modal="true" aria-label="' + p.name + ' quick view">' +
        '<div class="qv-media">' +
          '<img src="' + SQ.photo(p.id, 1) + '" alt="' + p.name + '" style="width:100%;height:100%;object-fit:cover;display:block">' +
        '</div>' +
        '<div class="qv-body">' +
          '<div class="qv-top"><span class="tag tag-outline">' + (p.badge || SQ.CATS[p.cat]) + '</span>' +
            '<button class="qv-x" data-qv-close aria-label="Close quick view">×</button></div>' +
          '<div><strong class="qv-name">' + p.name + '</strong><span class="qv-no">NO. ' + p.no + '</span></div>' +
          '<span class="rating"><span class="star">★</span> ' + p.rating + ' <i>(' + p.count + ' reviews)</i></span>' +
          '<p class="qv-benefit">' + p.benefit + '</p>' +
          '<div class="qv-price"><strong>' + SQ.fmt(SQ.UNIT) + '</strong></div>' +
          '<button class="kc kc--accent" data-qv-add>Add to cart · ' + SQ.fmt(SQ.UNIT) + '</button>' +
          '<span class="qv-fine">Cash on delivery · reaches you by ' + SQ.deliveryDate(4) + '</span>' +
          '<a class="ulink ulink--sm" href="' + SQ.urlOf(p.id) + '">Full details →</a>' +
        '</div>' +
      '</div>';

    qvRoot.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  /* ────────────────────────  collector's meter  ────────────────────────── */
  var elHeadline = document.querySelector('[data-set-headline]');
  var elMeterCount = document.querySelector('[data-meter-count]');
  var elSetCta = document.querySelector('[data-set-cta]');
  var elMbarPrice = document.querySelector('[data-mbar-price]');
  var elMbarSub = document.querySelector('[data-mbar-sub]');

  function renderMeter(cart) {
    var t = SQ.totals(cart);

    elHeadline.textContent = t.setDone ? 'That is three.' : 'Any three shapes, ₹2,199.';
    elMeterCount.textContent = t.distinct;

    document.querySelectorAll('[data-meter-sq]').forEach(function (el, i) {
      el.classList.toggle('is-on', i < t.distinct);
    });

    elSetCta.textContent = t.setDone ? 'Review your set →'
      : t.distinct === 0 ? 'Add three · ' + SQ.fmt(2199)
        : 'Add ' + t.needed + ' more shape' + (t.needed === 1 ? '' : 's');

    elMbarPrice.textContent = t.count > 0 ? SQ.fmt(t.total) : SQ.fmt(SQ.UNIT);
    elMbarSub.textContent = t.count > 0 ? t.count + ' in cart' : '19 shapes';
    document.querySelector('[data-mbar-cta]').textContent = t.count > 0 ? 'View cart' : 'Start collecting';
  }

  /* ─────────────────────────────  events  ──────────────────────────────── */
  elChips.addEventListener('click', function (e) {
    var b = e.target.closest('[data-chip]');
    if (!b) return;
    state.fCat = b.getAttribute('data-chip');
    renderChips(); renderGrid(); syncUrl();
  });

  if (elFeels) {
    elFeels.addEventListener('click', function (e) {
      var b = e.target.closest('[data-feel]');
      if (!b) return;
      state.fFeel = b.getAttribute('data-feel');
      renderChips(); renderGrid(); syncUrl();
    });
  }

  elSort.addEventListener('change', function (e) {
    state.sort = e.target.value;
    renderGrid();
  });

  /* [data-add] is handled globally in store.js (confirm + add together) */
  elGrid.addEventListener('click', function (e) {
    var qv = e.target.closest('[data-qv]');
    if (qv) { state.qv = qv.getAttribute('data-qv'); renderQv(); }
  });

  qvRoot.addEventListener('click', function (e) {
    if (e.target.closest('[data-qv-close]')) { state.qv = null; return renderQv(); }
    if (e.target.closest('[data-qv-add]')) {
      var id = state.qv;
      state.qv = null;
      renderQv();
      SQ.addItem(id, 1, true);
    }
  });

  elSetCta.addEventListener('click', function () {
    var cart = SQ.readCart();
    var t = SQ.totals(cart);
    if (t.setDone) return SQ.openDrawer();
    SQ.suggestMissing(cart, t.needed).forEach(function (id, i, arr) {
      SQ.addItem(id, 1, i === arr.length - 1);
    });
  });

  document.querySelector('[data-mbar-cta]').addEventListener('click', function () { SQ.openDrawer(); });

  SQ.onEsc = function () { if (state.qv) { state.qv = null; renderQv(); } };

  /* ──────────────────────────────  boot  ───────────────────────────────── */
  renderChips();
  renderGrid();
  SQ.onChange(renderMeter);
})();
